<nz-spin [nzSpinning]="loading" [nzTip]="dataMsg"> 
<form [formGroup]="form" (ngSubmit)="onSubmit()" nz-form [nzLayout]="'vertical'">

  <nz-form-item>
    <nz-form-label nzRequired [nzSpan]="24">Request Title</nz-form-label>
    <nz-form-control [nzErrorTip]="'Request title is required'">
      <input nz-input formControlName="request_title" placeholder="Enter request title" />
    </nz-form-control>
  </nz-form-item>

  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label nzRequired>Due Date</nz-form-label>
        <nz-form-control [nzErrorTip]="'Due date is required'">
          <nz-date-picker formControlName="due_date" nzFormat="yyyy-MM-dd"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col [nzSpan]="16"> 
    <nz-form-item>
          <nz-form-label>Timezone</nz-form-label>
          <nz-form-control>
            <nz-select nzShowSearch nzAllowClear formControlName="time_zone" id="timezone" nzPlaceHolder="Time zone" (nzOnSearch)="onTimezoneSearch($event)">
              @for (zone of timezones; track zone.id) {
                <nz-option   [nzValue]="zone.id" [nzLabel]="`${zone.name} (${zone.offset})`"></nz-option>
              }
            </nz-select>
          </nz-form-control>
    </nz-form-item>
    </div>
  </div>
   
      <nz-form-item>
        <nz-form-label nzRequired>Outsourcing Type</nz-form-label>
        <nz-form-control [nzErrorTip]="'Outsourcing type is required'">
          <nz-select nzShowSearch nzAllowClear formControlName="outsourcing_event_request" placeholder="Select outsourcing type"
          (ngModelChange)="getForms($event)"
          >
            <nz-option *ngFor="let item of 
            outsourcingRequestResponseModel.value.results" 
            [nzValue]="item.id" [nzLabel]="item.outsourcing_type_details?.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
 
  

  <nz-form-item>
    <nz-form-label nzRequired>Select Form</nz-form-label>
    <nz-form-control [nzErrorTip]="'Form selection is required'">
      <nz-select nzShowSearch nzAllowClear formControlName="outsourcing_form" placeholder="Select form"
     [nzDisabled]="!form.get('outsourcing_event_request')?.value" >
        <nz-option *ngFor="let form of 
        outsourcingFormsResponseModel.value.results" [nzValue]="form.id" [nzLabel]="form.name"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>General Instructions for Vendors</nz-form-label>
    <nz-form-control>
        <quill-editor
          theme="snow"
          placeholder="Enter instructions"
          class="content-editor"
          [modules]="quillConfig"
          formControlName="general_instructions_for_vendors">
        </quill-editor>
    </nz-form-control>
  </nz-form-item>

  <button style="float: inline-end;" nz-button nzType="primary" [disabled]="form.invalid">Submit</button>
  <div style="margin-bottom: 50px;"></div>
</form>
</nz-spin>